const ONE_MINUTE_SECOND = 60;

/**
 * 収録時間（秒数）を「分形式」または「秒形式」に変換する関数
 * @param duration 秒数
 * @returns 空文字 | ${number}秒 | ${number}分
 */
export const durationTimeText = (duration: number) => {
  // 0秒の場合は「空文字」を返却すること
  if (duration === 0) return "";

  // 1分未満であれば、秒表示すること
  if (ONE_MINUTE_SECOND > duration) return `${duration}秒`;

  // 1分31秒であれば「2分」と表示すること
  if (duration % ONE_MINUTE_SECOND > 30) {
    return `${Math.floor(duration / ONE_MINUTE_SECOND) + 1}分`;
  } else {
    // 1分30秒であれば「1分」と表示すること
    return `${Math.floor(duration / ONE_MINUTE_SECOND)}分`;
  }
};
